import { render, staticRenderFns } from "./DashboardStore.vue?vue&type=template&id=34d37b7b&scoped=true&"
import script from "./DashboardStore.vue?vue&type=script&lang=js&"
export * from "./DashboardStore.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStore.vue?vue&type=style&index=0&id=34d37b7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d37b7b",
  null
  
)

export default component.exports